import clsx from "clsx";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  className?: string;
  variant?: "blob" | "ribbon";
  /** raw gradient applied beneath the mask. defaults to an aurora gradient. */
  fill?: string;
};

/**
 * Liquid-masked surface — animated SVG mask makes the gradient flow
 * like water beneath the children. Use for accent panels (stats, callouts).
 */
export function LiquidCard({ children, className, variant = "blob", fill }: Props) {
  const gradient =
    fill ??
    "linear-gradient(135deg, #06b6d4 0%, #10b981 30%, #c4b5fd 60%, #fb7185 100%)";

  return (
    <div
      className={clsx(
        "relative rounded-[var(--radius-card)] overflow-hidden",
        "border border-white/10 bg-night-900/40 backdrop-blur-md",
        className,
      )}
    >
      {/* the flowing fill — sits behind content via z-index, masked into a liquid shape */}
      <div
        aria-hidden
        className={clsx(
          "absolute inset-0 -z-0 opacity-80",
          variant === "blob" ? "liquid-mask" : "liquid-ribbon",
        )}
        style={{ background: gradient }}
      />
      <div
        aria-hidden
        className="absolute inset-0 -z-0 mix-blend-overlay"
        style={{
          background:
            "radial-gradient(120% 80% at 50% 0%, rgba(255,255,255,0.18), transparent 60%)",
        }}
      />
      <div className="relative z-10 p-6 md:p-8">{children}</div>
    </div>
  );
}
